module.exports = __webpack_public_path__ + "static/media/blog.8c458af4.svg";